import { Routes, Route } from 'react-router-dom';
import Navbar from './components/navbar';
import Footer from './components/footer';
import LoginForm from './registration/login';
import PropertyListings from './pages/PostProperty';
import ResidentialRentForm from './forms/Residential/rent';
import ResidentialResaleForm from './forms/Residential/resale';
import ResidentialLeaseForm from './forms/Residential/lease';
import LandResaleForm from './forms/Land/resale';
import PropertyListOut from './main/PropertyListOut';
import IndexSearch from './components/IndexSearch';
import BasicSubscription from './payments/subscription/basic_subscription'
import PropertyView from './main/PropertyView';
import './assets/js/search/IndexSearch'
import AdminPropertyManagement from './admin/AdminPropertyManagement';
import ContactUs from './components/ContactUs';

// Calculator
import Calculators from './calculators/Calculators';
import BrokerageCalculator from './calculators/BrokerageCalculator';
import PlotCalculator from './calculators/PlotCalculator';
import HomeLoanCalculator from './calculators/HomeLoanCalculator'

// Material Room
import MaterialRoom from './construction/materialRoom';
import MaterialView from './construction/materialView';
import MaterialForm from './forms/Construction/materialForm';


function Home() {
  return (
    <>
      
      <h3 className='text-center text-info'>World's Largest NoBrokerage Property Site</h3>
      <IndexSearch />
      <div className="mt-3" id="tabContent">
        <p>Currently viewing: <strong>Buy</strong></p>
      </div>
      <PropertyListOut />
      <div className='text-center'>
        <button className='btn btn-success'>Show More</button>
      </div>
    </>
  );
}

function App() {
  return (
    <div className='container-fluid'>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginForm />} />
        <Route path="/property_post" element={<PropertyListings />} />
        <Route path="/residential/rent_form" element={<ResidentialRentForm />} />
        <Route path="/residential/resale_form" element={<ResidentialResaleForm />} />
        <Route path="/residential/lease_form" element={<ResidentialLeaseForm />} />
        <Route path="/land/resale_form" element={<LandResaleForm />} />
        <Route path="/subscription/basic" element={<BasicSubscription />} />
        <Route path="/property/:id" element={<PropertyView />} />
        <Route path='/contact_us' element={<ContactUs />} />
        <Route path="/admin/property_management" element={<AdminPropertyManagement />} />
        <Route path="/construction/material_room" element={<MaterialRoom />} />
        <Route path="/construction/material_room/material_form" element={<MaterialForm />} />
        <Route path="/construction/material_room/room_code/:roomid" element={<MaterialView />} />
        <Route path="/calculators" element={<Calculators />} />
        <Route path="/calculator/brokerage_calculator" element={<BrokerageCalculator />} />
        <Route path="/calculator/plot_calculator" element={<PlotCalculator />} />
        <Route path="/calculator/home_loan_calculator" element={<HomeLoanCalculator />} />


      </Routes>

      <Footer />
    </div>
  );
}

export default App;
